import React, { useState, useRef } from 'react';
import {
    Tooltip,
    IconButton,
} from '@material-ui/core';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import LinkIcon from '../../icons/Link';
import QuickLinksPopover from './QuickLinksPopover';

const useStyles = makeStyles<Theme>(() =>
    createStyles({
        iconButton: {
            cursor: 'pointer',
        },
    })
);

interface LinksWidgetProps {
    disabled?: boolean;
}

const LinksWidget: React.FC<LinksWidgetProps> = ({ disabled = false }) => {
    const classes = useStyles();
    const anchorRef = useRef<HTMLButtonElement | null>(null);
    const [open, setOpen] = useState<boolean>(false);

    const handleIconClick = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    if (disabled) {
        return null;
    }

    return (
        <>
            <Tooltip title="Quick Links">
                <IconButton
                    ref={anchorRef}
                    onClick={handleIconClick}
                    className={classes.iconButton}
                    size='small'
                    sx={{ color: '#718096' }}
                >
                    <LinkIcon fontSize="small" />
                </IconButton>
            </Tooltip>

            <QuickLinksPopover
                anchorEl={anchorRef.current}
                open={open}
                onClose={handleClose}
            />
        </>
    );
};

export default LinksWidget;
